import { Box, Heading, Spinner, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const AuthenticatingSection = () => {
  const { t } = useTranslation();

  return (
    <Box
      p={8}
      bg="rgba(13, 13, 21, 0.8)"
      borderRadius="xl"
      boxShadow="0 8px 32px rgba(0, 0, 0, 0.4)"
      border="1px solid"
      borderColor="whiteAlpha.100"
      backdropFilter="blur(12px)"
      w="100%"
      textAlign="center"
    >
      <VStack spacing={6}>
        <Heading as="h3" size="md" color="cyan.300" fontWeight="500" letterSpacing="0.05em">
          {t("Authenticating")}
        </Heading>
        <Spinner color="cyan.300" size="xl" thickness="3px" />
      </VStack>
    </Box>
  );
};

export default AuthenticatingSection;
